import { functions } from './firebase';
import { pipedriveAppEnabled } from './lib/pipedriveApp';

export type PipedriveCallableRequest =
  | {
      requestType: 'SEARCH_ORGS';
      searchTerm: string;
    }
  | {
      requestType: 'GET_ORGS';
      start?: number;
      limit?: number;
    }
  | {
      requestType: 'GET_ORG';
      id: number;
    }
  | {
      requestType: 'GET_ORG_DEALS';
      id: number;
    }
  | {
      requestType: 'SEARCH_DEALS';
      searchTerm: string;
    }
  | {
      requestType: 'GET_DEALS';
      start?: number;
      limit?: number;
      filterId?: number;
    }
  | {
      requestType: 'SEARCH_LINKABLE_DEALS';
      searchTerm: string;
      limit?: number;
    }
  | {
      requestType: 'LINK_APP_DEAL';
      appDealId?: string;
      offerId?: string;
      dealId: number;
      orgId?: number | null;
    }
  | {
      requestType: 'LINK_APP_ORG';
      appOrgId?: string;
      orgId?: string;
      dealId: number;
      pipedriveOrgId?: number | null;
    }
  | {
      requestType: 'SYNC_APP_DEAL';
      appDealId?: string;
      offerId?: string;
    };

const pipedriveCallable = functions.httpsCallable('pipedrive');

export async function callPipedrive<T = any>(data: PipedriveCallableRequest) {
  if (!pipedriveAppEnabled()) throw new Error('Pipedrive-visningen er lukket. Brug CRM.');
  return pipedriveCallable(data) as Promise<{ data: T }>;
}
